import React from "react";

import { ScheduleContent } from "@src/features/scheduleExperience/ScheduleContent";
import { ScheduleProps } from "@src/features/scheduleExperience/types";

export const StartSchedule = ({
  experience,
  isLoading,
  setDateTime,
  dateTime,
  timeNow,
  disabledReason,
  isStartSet,
  pauseAtSchedule,
  endAtSchedule,
  setErrors,
}: ScheduleProps) => {
  return (
    <ScheduleContent
      setErrors={setErrors}
      isLoading={isLoading}
      label={"Start"}
      experience={experience}
      minScheduleTime={timeNow}
      action={"start"}
      setDateTime={setDateTime}
      dateTime={dateTime}
      disabledReason={disabledReason}
      isStartSet={isStartSet}
      pauseAtSchedule={pauseAtSchedule}
      endAtSchedule={endAtSchedule}
      timeNow={timeNow}
    />
  );
};
